// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DefaultTheme__divider___2-6UQ {
  border-top: 1px solid var(--_apc-sidebar-border, var(--aluminum2));
  list-style-type: none;
  margin: 30px 20px;
}
`, "",{"version":3,"sources":["webpack://./../node_modules/@mulesoft/anypoint-components/raw/platform-components/SidebarDivider/themes/DefaultTheme.css"],"names":[],"mappings":"AAAA;EACE,kEAAkE;EAClE,qBAAqB;EACrB,iBAAiB;AACnB","sourcesContent":[".DefaultTheme__divider___2-6UQ {\n  border-top: 1px solid var(--_apc-sidebar-border, var(--aluminum2));\n  list-style-type: none;\n  margin: 30px 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
